export interface AvailabilityBooking {
  id: string;
  date: string; // YYYY-MM-DD
  time: string; // HH:mm
  status: string;
  serviceId: string | null;
  serviceName: string | null;
  duration: number; // minutes
}

export interface AvailabilityResponse {
  start: string;
  end: string;
  bookings: AvailabilityBooking[];
}

const toQueryString = (params: Record<string, string>) => {
  const searchParams = new URLSearchParams(params);
  return searchParams.toString();
};

export async function fetchAvailability(start: string, end: string): Promise<AvailabilityResponse> {
  const query = toQueryString({ start, end });
  const response = await fetch(`/api/get-availability?${query}`);

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Failed to fetch availability. Status: ${response.status}`);
  }

  const data = (await response.json()) as AvailabilityResponse;
  return data;
}
